export const NAV_ITEMS_MODE = Object.freeze({
  SYSTEM: "system",
  MSP: "msp",
  CUSTOMER_ADMIN: "customer_admin",
  PROFILE: "profile",
});

export default {};
